export default __webpack_public_path__ + "static/media/03.7e40c4eb.webp";